export default {
    SET_REF_STATUS: (state, refStatus) => {
        state.refStatus = refStatus
    },

    SET_CONFIRMED_LENGTH: (state, confirmedLength) => {
        state.confirmedLength = confirmedLength
    },

    SET_FORMATTED_PHONE: (state, formattedPhone) => {
        state.formattedPhone = formattedPhone
    },

    SET_REFERRAL_CODE_EXIST: (state, isReferralCodeExist) => {
        state.isReferralCodeExist = isReferralCodeExist
    },

    SET_SESSION_TOKEN: (state, sessionToken) => {
        state.sessionToken = sessionToken
    },

    SET_REFERRAL_CODE: (state, referralCode) => {
        state.referralCode = referralCode
    }
}
